import React from 'react';
import { Box, Stack } from '@mui/material';
import { Logo } from './Logo';

export const Header = props => {
  const { isDesktop, redirectUrl } = props;

  return (
    <Stack direction={isDesktop ? 'row' : 'column'} justifyContent="space-between" alignItems="center" p={2} sx={{
      background: 'linear-gradient(90deg, #1256A7 0%, #44B9D6 100%)'
    }}>
      <Logo isDesktop={isDesktop} />
      <Box
        onClick={() => window.location.assign(redirectUrl)}
        component="img"
        src="/static/Powrót do strony Sun Sport.png"
        sx={{ cursor: 'pointer', width: 250, height: 40, objectFit: 'contain' }} />
    </Stack>
  );
};
